module.exports = __webpack_public_path__ + "static/media/searchIcon.feb51724.svg";